import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { Switch, useLocation } from 'react-router';
import Routes, { getRoutes, getSubRoutes } from './Routes';
import Workspace from './Workspace';

export default function RouteRenderer() {
  const background = useSelector((state) => state.page.background);

  const location = useLocation();
  // Scroll to top if path changes
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Switch>
      {getRoutes(Routes)}
      <Workspace background={background}>
        <Switch>{getSubRoutes(Routes)}</Switch>
      </Workspace>
    </Switch>
  );
}
